
export type TipContext = 'buy' | 'sell' | 'inspection' | 'parts' | 'general';

export interface Tip {
  id: string;
  context: TipContext;
  text_ar: string;
  priority: number;
}

export const TIPS_DATABASE: Tip[] = [
  { id: '1', context: 'general', text_ar: "نصيحة: فحص زيت المحرك دورياً يحميك من أعطال مكلفة جداً.", priority: 1 },
  { id: '2', context: 'buy', text_ar: "نصيحة: قارن السعر مع سيارات مشابهة في نفس سنة الصنع قبل اتخاذ قرار الشراء.", priority: 2 },
  { id: '3', context: 'sell', text_ar: "نصيحة: إضافة صور واضحة من زوايا متعددة ترفع فرص البيع بنسبة 40%.", priority: 2 },
  { id: '4', context: 'parts', text_ar: "نصيحة: تأكد من توافق رقم القطعة (SKU) مع موديل سيارتك بدقة.", priority: 2 },
  { id: '5', context: 'inspection', text_ar: "نصيحة: الأعطال البسيطة في لوحة العدادات قد تخفي مشاكل ميكانيكية عميقة.", priority: 2 },
  { id: '6', context: 'general', text_ar: "هل تعلم؟ ضغط الإطارات الصحيح يقلل من استهلاك الوقود بنسبة 3%.", priority: 1 },
  { id: '7', context: 'buy', text_ar: "نصيحة: اطلب تقرير الحوادث (VIN) دائماً قبل معاينة السيارة على الطبيعة.", priority: 3 },
  { id: '8', context: 'sell', text_ar: "نصيحة: اذكر سجل الصيانة في الوكالة، فهو يطمئن المشترين ويزيد السعر.", priority: 3 },
  { id: '9', context: 'parts', text_ar: "نصيحة: القطع الأصلية تدوم بمعدل 3 أضعاف القطع التجارية المقلدة.", priority: 3 },
  { id: '10', context: 'inspection', text_ar: "نصيحة: افحص البطارية قبل دخول فصل الشتاء لتجنب التوقف المفاجئ.", priority: 2 }
];

export function getContextualTips(context: TipContext, limit: number = 3): Tip[] {
  return TIPS_DATABASE
    .filter(tip => tip.context === context || tip.context === 'general')
    .sort(() => Math.random() - 0.5)
    .slice(0, limit);
}
